// https://stackoverflow.com/questions/42118296/dynamically-import-images-from-a-directory-using-webpack

export function importAll(r) {
  return r.keys().map(r);
}
